import React from 'react';

function ActivitiesIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="164"
      height="164"
      viewBox="0 0 164 164"
      className={className}
    >
      <path
        fill="#FFF"
        fillOpacity="0.2"
        fillRule="evenodd"
        d="M61.598 44.235l40.616-16.44a6.804 6.804 0 014.447-.235c.56.1 1.107.27 1.628.507l38.039 17.29a6.833 6.833 0 014.005 6.22v87.312a6.833 6.833 0 01-10.227 5.931l-35.224-20.155-40.28 20.523a6.834 6.834 0 01-7.189-.61l-40.137-21.473a6.833 6.833 0 01-3.61-6.025V34.193a6.833 6.833 0 019.507-6.289l38.425 16.33zm-38.82-6.599v78.08l36.444 19.497V53.125L22.778 37.636zm82 62.586l16.058 8.442h.003c.002 0 .004-.002.003-.004l-3.066-17.881 12.99-12.663.002-.003c0-.003-.001-.005-.004-.005l-17.953-2.609-8.03-16.269-.001-.002c-.002 0-.005 0-.006.002l-8.03 16.27-17.953 2.609-.002.001a.006.006 0 000 .007L91.78 90.779l-3.067 17.88v.003c.002.003.005.004.007.002l16.058-8.442z"
      />
    </svg>
  );
}

export default ActivitiesIcon;
